import {
  oplogExportHudStartJob,
  oplogExportHudEndPreparing,
  oplogExportHudHideToast,
  oplogExportHudFinishJob,
} from './oplogExportHud.store';
import { empDownloadHudClose } from './empDownloadHud.store';

/** @param {Date} [d] */
export function formatClientExportTimestamp(d = new Date()) {
  const pad = (n) => String(n).padStart(2, '0');
  return (
    `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}` +
    `${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`
  );
}

function createUtf8CsvBlob(csvContent) {
  return new Blob(['\uFEFF', csvContent], { type: 'text/csv;charset=utf-8;' });
}

export function downloadUtf8CsvFile(csvContent, fileName) {
  const blob = createUtf8CsvBlob(csvContent);
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(link.href);
}

/**
 * 与操作日志导出共用 oplogExportHud + EmpDownloadHudHost 右下角进度条。
 * @param {object} opts
 * @param {string} [opts.contextLabel] Toast 右侧上下文（如类型名/公司名）
 * @param {string} [opts.progressTitle] 覆盖进度标题（空则用操作日志默认文案）
 * @param {string} [opts.progressSubtitle] 覆盖进度副标题
 * @param {(api: { endPreparing: Function, hideToast: Function }) => Promise<void>} opts.job
 */
export async function runClientExportWithHud({
  contextLabel = '',
  progressTitle = '',
  progressSubtitle = '',
  job,
}) {
  empDownloadHudClose();
  oplogExportHudStartJob(contextLabel, { title: progressTitle, subtitle: progressSubtitle });
  try {
    await job({
      endPreparing: oplogExportHudEndPreparing,
      hideToast: oplogExportHudHideToast,
    });
    await new Promise((r) => setTimeout(r, 2000));
    oplogExportHudHideToast();
  } finally {
    oplogExportHudFinishJob();
  }
}
